<template>
  <div class="wrap">
    <p class="description">Summing up all of your roster player averages this season, useful to compare how you would do against any of your matchups if you had the same number of games per player.
      <br/>
      <span class="warning">Note: Takes into account injured players. I'll be adding a filter soon</span>
    </p>
    <div class="top-dropdown">
      <h3 class="nav-panel-header">
        <span>Stats for: </span>
      </h3>
      <form @submit.prevent>
        <select v-model="tableIndex">
          <option :value="i" v-for="(table, i) in rosterCompare" v-bind:key="i">{{table.name}}</option>
        </select>
      </form>
      <br/>

    </div>
    <div class="setting">
      <label for="injuries">
        <p>Include injured players:</p>
        <input type="checkbox" id="injuries" v-model="stats_with_injuries"/>
      </label>
    </div>
    <div class="table-wrap">
      <div class="fl-table" v-if="viewChosen">
        <div class="fl-row header-row">
          <div class="fl-row-inner">
            <table-cell>
              <h3 class="h6">Team</h3>
            </table-cell>
            <table-cell v-for="(category, i) in rosterCompare[tableIndex].columns" v-bind:key="i" class="fl-cell">
              <h3 class="h6">{{category.display_name}}</h3>
            </table-cell>
          </div>
        </div>
        <div class="table-content">
          <div v-for="(row, i) in rosterCompare[tableIndex].rows" v-bind:key="i" class="fl-row"
              :class="{'your-row': row.team && row.team.is_owned_by_current_login, 'highlight': !row.team}">
              <div class="fl-row-inner">
              <table-cell>
                <p v-if="row.team">
                  {{row.team.name}}
                </p>
              </table-cell>
              <template v-if="row.team && row.team.is_owned_by_current_login">
                <table-cell
                v-for="(score, j) in row.scores"
                v-bind:key="j"
                :value="getScoreValue(score).strValue ? getScoreValue(score).strValue : getScoreValue(score).value"
              />
              </template>
              <template v-else>
                <table-cell
                v-for="(score, j) in row.scores"
                v-bind:key="j"
                :class="{
                  'victory': getScoreValue(score).lost_matchup === false,
                  'defeat': getScoreValue(score).lost_matchup === true
                }"
                :value="getScoreValue(score).strValue ? getScoreValue(score).strValue : getScoreValue(score).value"
              />
              </template>



            </div>
          </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import tableCell from '@/components/cell/cell.vue'
export default {
  name: "compare-rosters",
  data() {
    return {
      rosterCompare: [],
      tableIndex:0,
      rosterRequest: false,
      stats_with_injuries: false
    };
  },
  components: {
    'table-cell': tableCell
  },
  props: ["leagues", "selectedLeague", "loaded", "leagueName", "refreshLeague"],
  computed: {
    viewChosen: function () {
      return this.leagueName && this.rosterRequest;
    },
  },
  created: function () {
    if (this.selectedLeague.yahoo_object.league_key) {
      this.selectCategory();
    }
  },
  methods: {
    selectCategory: async function () {
      try {
        this.$store.dispatch("isLoading", true);
        this.rosterCompare = await this.$store.state.apiService.getRosterCategoryCompare(
          this.selectedLeague.yahoo_object.league_key
        );

      } catch (e) {
        if (e.response && e.response.status && e.response.status === 403) {
          this.$store.dispatch("login", true);
        }
      } finally {
        this.$store.dispatch("isLoading", false);
        this.rosterRequest = true;
      }
    },
    getScoreValue: function(score) {
      return this.stats_with_injuries ? score.all: score.withoutInjuries;
    }
  },
  watch: {
    leagueName: function () {
      this.selectCategory();
    },
    refreshLeague: function () {
      this.selectCategory();
    },
  },
};
</script>

<style src="./compare-rosters.styl" lang="stylus" scoped></style>
